<template>
    <div v-if="objectIsNotEmpty(outlets) && objectIsNotEmpty(tabsToRender)">
<!--        TODO set up outlet tabs smallify.-->
        <np-router-toptabs
                :type="'smallify'"
                :buttons-config="outletBtnConfig"
                @buttonclick="deleteOutlet"
                :tabs-config="tabsToRender">
        </np-router-toptabs>
        <router-view></router-view>
    </div>
    <div v-else>
        <np-notice :dismissable="false" :notice="lang('select_outlets_in_business_info')"></np-notice>
    </div>
</template>

<script>
    import {mapActions} from "pinia";
    import applicationMixin from "../../../utils/application-mixin";
    import utilMixin from "../../../utils/mixins";
    import {NPRouterTopTabs, NPNotice} from "netpify/components";
    import * as types from "../../../stores/constants";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "Outlets",
        mixins: [utilMixin, applicationMixin],
        components: {
            'np-router-toptabs': NPRouterTopTabs,
            'np-notice': NPNotice,
        },
        data() {
            return {
                outlet_tab : {
                    display: true,
                    is_active: false,
                    is_open: false,
                    label: "tab_outlet",
                    lang_key: "tab_outlet",
                    // lang_key: "",
                    tab_id: "tab_outlet",
                    url_router: "",
                },
                outlet_ref: '',
            }
        },
        mounted() {
            this.fetchData();
        },
        computed: {
            outletBtnConfig: function (){
              return [
                  // {type: 'cancel', url: '', class: 'btn-xs btn btn-danger'}
              ]
            },
            outlets: function (){
                return this.objectIsNotEmpty(this.merchant_relation.outlets) ? this.merchant_relation.outlets : [];
            },
            parameters: function () {
                this.$parent.parameters;
            },
            tabsToRender: function () {
                let tabs = [];

                // //console.log(this.outlets);
                if (this.objectIsNotEmpty(this.outlets)){
                    this.outlets.forEach((obj, index) => {
                        let tab = {
                                display: true,
                                is_active: false,
                                is_open: false,
                                label: "tab_outlet",
                                tab_id: "tab_outlet",
                                url_router: "outlets/",
                            },
                            outlet_num = index + 1;
                        tab.tab_id = !!obj.outlet_ref ? obj.outlet_ref : outlet_num;
                        tab.label = this.lang(tab.label) + ' ' + outlet_num;
                        // tab.url_router = this.application_root_path + tab.url_router + tab.tab_id;
                        tab.url_router = tab.url_router + tab.tab_id;
                        tabs.push(tab)
                    })
                }
                return tabs;
            }
        },
        methods: {
            ...mapActions(useApplicationStore, [types.SET_OUTLET_IN_FOCUS]),
            fetchData: function () {
                let outlet_ref = this.$route.params.outlet_ref;
                let outlet = {};
                if (this.objectIsNotEmpty(this.outlets)){
                    outlet = this.outlets.find(obj => {
                        return obj.outlet_external_id === outlet_ref
                    })

                    if (!this.objectIsNotEmpty(outlet)){
                        let index = parseInt(outlet_ref) - 1
                        outlet = this.outlets[index];
                    }

                    this[types.SET_OUTLET_IN_FOCUS](outlet);
                }
                this.outlet_ref = outlet_ref;
            },
            deleteOutlet: function () {
                //TODO delete current outlet.
                //TODO find outlet in outlets block and delete
                //also delete the current tab from the toptabs
            }
        },
        watch: {
            '$route.params.outlet_ref' : 'fetchData'
        }

    }
</script>

<style scoped>

</style>